"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorAlert = exports.ErrorAlert = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const IError_1 = require("@reactionable/core/lib/error/IError");
const ErrorAlert_1 = require("@reactionable/core/lib/ui/alert/ErrorAlert");
const Alert_1 = require("./Alert");
const ErrorAlert = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return (jsx_runtime_1.jsx(Alert_1.Alert, Object.assign({ variant: "danger", icon: { icon: free_solid_svg_icons_1.faExclamationTriangle } }, props, { children: IError_1.printError(children) }), void 0));
};
exports.ErrorAlert = ErrorAlert;
const useErrorAlert = (props) => {
    return ErrorAlert_1.useErrorAlert(Object.assign({ Component: exports.ErrorAlert }, props));
};
exports.useErrorAlert = useErrorAlert;
//# sourceMappingURL=ErrorAlert.js.map